/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantBankListDto } from '../models/PagedResultDto_ParticipantBankListDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_GetDropdownParticipantBankListAsync } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_GetDropdownParticipantBankListAsync';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankForView } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankForView';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankListDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankListDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ToggleManualBankAccountStatusDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ToggleManualBankAccountStatusDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto';
import type { Wealthlane_Shared_Hosting_FinanceService_Grpc_LiveMarketValueResponse } from '../models/Wealthlane_Shared_Hosting_FinanceService_Grpc_LiveMarketValueResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBankService {

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantBankListDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankParticipantBankList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantBankListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/participant-bank-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankListDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankParticipantBankAllList(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/participant-bank-all-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_GetDropdownParticipantBankListAsync OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankDropdownParticipantBankList(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_GetDropdownParticipantBankListAsync>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/dropdown-participant-bank-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankLinkToken(): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/link-token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankLinkTokenForManualBankAccountVerification(
participantBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/link-token-for-manual-bank-account-verification/{participantBankId}',
            path: {
                'participantBankId': participantBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankForView OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankParticipantBankForView(
participantBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankForView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/participant-bank-for-view/{participantBankId}',
            path: {
                'participantBankId': participantBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankSavePublicTokenMetaData(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank/save-public-token-meta-data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankVerifyManualBankAccount(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_SavePublicTokenMetaDataForParticipantDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank/verify-manual-bank-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiFinanceIntegrationApiAppParticipantBankParticipantBankAccount(
participantBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/finance-integration/api/app/participant-bank/participant-bank-account/{participantBankId}',
            path: {
                'participantBankId': participantBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankRegisterManualBankAccount(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank/register-manual-bank-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankToggleManualBankStatusAccount(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ToggleManualBankAccountStatusDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank/toggle-manual-bank-status-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankVerifyManualBankStatusAccount(
id: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank/{id}/verify-manual-bank-status-account',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankAccountType(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/account-type',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankRoutingType(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/routing-type',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Shared_Hosting_FinanceService_Grpc_LiveMarketValueResponse OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankClosePriceCheck(): CancelablePromise<Wealthlane_Shared_Hosting_FinanceService_Grpc_LiveMarketValueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank/close-price-check',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
